import { buildLengthMString } from './extract';
import { createPdfTableBlob } from './pdf-common';
import { type ExportHeaderInfo, type CableTypeExportRow } from './types';

export const buildCableTypePdfBlob = (
  data: CableTypeExportRow[],
  filename: string,
  headerInfo?: ExportHeaderInfo,
): { blob: Blob; filename: string } => {
  const head = ['Type', 'Length (M)', 'Quantity'];
  const body = data.map((row) => [
    row.Type,
    buildLengthMString(row['Length (M)'], 'pdf'),
    String(row.Quantity),
  ]);
  return createPdfTableBlob(head, body, filename, headerInfo);
};
